<script lang="ts">
    export let size_to_container = false
    export let invert_colors = false
    export let tiny = false
</script>

<span
    class="loader"
    class:invert_colors
    class:tiny
    style:width={size_to_container ? "100%" : "30px"}
    style:height={size_to_container ? "100%" : "30px"}
/>

<style>
.loader {
  border: 5px solid rgba(0, 0, 0, 0.2);
  border-bottom-color: white;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.loader.invert_colors {
  border: 5px solid rgba(0, 0, 0, 0.2);
  border-bottom-color: var(--title);
}
.loader.tiny {
  border-width: 3px;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
